import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import apiFetchBalanceModificationTransactionsEdit from '../../api/BalanceModificationTransactionsEditAPI';
import { BOH_TRANSACTIONS_EDIT_REQUEST } from '../actions/types/BalanceModificationTransactionsEditActionsTypes';
import { putBOHTransactionsEditSuccessActionCreator, putBOHTransactionsEditFailureActionCreator } from '../actions/BalanceModificationTransactionsEditActions';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';

function* doBOHTransactionsEditWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchBalanceModificationTransactionsEdit, action.payload);
    yield put(putBOHTransactionsEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: <FormattedMessage
        id="notification.bohtransaction.edit.success"
        values={{ transactionProcessingFrequency: process.env.transactionProcessingFrequency }}
      />,
    }));
  } catch (error) {
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
    yield put(putBOHTransactionsEditFailureActionCreator(error));
  }
}

function* doBOHTransactionsEditWatcher() {
  yield takeLatest(BOH_TRANSACTIONS_EDIT_REQUEST, doBOHTransactionsEditWorker);
}

export default doBOHTransactionsEditWatcher;
